import { handleError } from '@domain-group/fe-helper';

export const INFO_BRAND = 'Domain';

export interface Ga4PageProps {
  info_brand: string;
  info_category_page_type: string;
  info_category_primary: string;
  info_category_sub1: string;
  info_category_sub2: string;
  info_generator: string;
  info_page_id: string;
  info_page_name: string;
}

export interface Ga4UserProps {
  user_domain_user_id: string;
  user_email_hash_256: string;
  user_domain_profile_id: string;
  user_email_hash: string;
  user_membership_state: string;
  user_membership_type: string;
  user_session_token: string;
}

const emptyPageProps: Ga4PageProps = {
  info_brand: INFO_BRAND,
  info_category_page_type: '',
  info_category_primary: '',
  info_category_sub1: '',
  info_category_sub2: '',
  info_generator: '',
  info_page_id: '',
  info_page_name: '',
};

const emptyUserProps: Ga4UserProps = {
  user_domain_user_id: '',
  user_email_hash_256: '',
  user_domain_profile_id: '',
  user_email_hash: '',
  user_membership_state: '',
  user_membership_type: '',
  user_session_token: '',
};

export const getGa4PageProps = (): Ga4PageProps => {
  if (typeof window === 'undefined') {
    return emptyPageProps;
  }

  try {
    const page = global?.window?.digitalData?.page;
    const pageInfo = page?.pageInfo;
    const category = page?.category;

    return {
      info_brand: INFO_BRAND,
      info_category_page_type: category?.pageType ?? '',
      info_category_primary: category?.primaryCategory ?? '',
      info_category_sub1: category?.subCategory1 ?? '',
      info_category_sub2: category?.subCategory2 ?? '',
      info_generator: pageInfo?.generator ?? '',
      info_page_id: pageInfo?.pageId ?? '',
      info_page_name: pageInfo?.pageName ?? '',
    };
  } catch (err) {
    handleError(err);
    return emptyPageProps;
  }
};

export const getGa4UserProps = (): Ga4UserProps => {
  if (typeof window === 'undefined') {
    return emptyUserProps;
  }

  try {
    const user = global?.window?.digitalData?.user;
    const profileInfo = user?.profile?.profileInfo;

    return {
      user_domain_user_id: profileInfo?.domainUserId ?? '',
      user_email_hash_256: user?.emailHash256 ?? '',
      user_domain_profile_id: profileInfo?.profileId ?? '',
      user_email_hash: user?.emailHash ?? '',
      user_membership_state: user?.membershipState ?? '',
      user_membership_type: user?.membershipType ?? '',
      user_session_token: user?.sessionToken ?? '',
    };
  } catch (err) {
    handleError(err);
    return emptyUserProps;
  }
};
